import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { RtUICoreOverlayModule } from '../../core/overlay/overlay.module';
import { ResultsLimitButtonComponent } from './results-limit-button.component';

@NgModule({
  imports: [CommonModule, I18nModule, RtUICoreOverlayModule, ResultsLimitButtonComponent],
  exports: [ResultsLimitButtonComponent],
})
export class ResultsLimitButtonModule {}

export { ResultsLimitButtonComponent };
